/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { BalancerTokenRouter } from "../BalancerTokenRouter";

export class BalancerTokenRouter__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<BalancerTokenRouter> {
    return super.deploy(overrides || {}) as Promise<BalancerTokenRouter>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): BalancerTokenRouter {
    return super.attach(address) as BalancerTokenRouter;
  }
  connect(signer: Signer): BalancerTokenRouter__factory {
    return super.connect(signer) as BalancerTokenRouter__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BalancerTokenRouter {
    return new Contract(address, _abi, signerOrProvider) as BalancerTokenRouter;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokensIn",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsIn",
        type: "uint256[]",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "initializeOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokensOut",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsOut",
        type: "uint256[]",
      },
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "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";
